<template>
  <div class="content pb-0">
    <div class="container-fluid">
      <div class="row">

        <div class="col-lg-7 col-md-12">
          <card class="striped-tabled-with-hover p-0 m-0"
                body-classes="table-full-width table-responsive p-0 m-0">
            <template slot="header">
              <h4 class="card-title">Producten <span v-if="productCount">(<b>{{productCount}}</b> / {{products.length}})</span></h4>
              <p class="card-category">Overzicht van de producten + verkopen</p>
            </template>

            <div class="row px-2">
              <div class="col">
                <input type="text" placeholder="Zoeken" class="form-control" style="border-radius: 0" v-model="search"/>
              </div>
              <div class="col text-center">
                <FilterModal :products="products" :filter="filter" :product-settings="productSettings"></FilterModal>
              </div>
              <div class="col text-center">
                <a class="btn btn-success btn-sm" @click="showImages = !showImages">Toon / verberg afbeeldingen</a>
              </div>
              <div class="col text-right">
                <a class="btn btn-link btn-sm" @click="exportToCsv()">Export CSV</a>
              </div>
            </div>
            <div class="row px-2 my-1">
              <div class="col-2">
                <label class="text-muted">Legenda</label>
              </div>
              <div class="col">
                <div class="badge badge-secondary">Product Merk</div> | <div class="badge badge-info">Product Categorie</div> | <div class="badge badge-warning">Toegevoegd sinds</div> | <div class="badge badge-primary">Leverancier</div>
              </div>
            </div>

            <div class="row  px-2 my-1">
              <div class="col">
                <label>Datum van</label>
                <input type="date" placeholder="Van" class="form-control" style="border-radius: 0" v-model="dateFrom"/>
                <label v-if="dateFrom"> Jaar Weeknummer: {{ new Date(dateFrom) | moment('YYYY w')}}</label>
              </div>
              <div class="col">
                <label>Datum tot</label>
                <input type="date" placeholder="Tot" class="form-control" style="border-radius: 0" v-model="dateTo"/>
                <label> Jaar Weeknummer: {{ new Date(dateTo) | moment('YYYY w')}}</label>
              </div>
            </div>

            <div style="height: calc(100vh - 250px); overflow-y: auto;">
              <table class="table table-hover table-striped table-condensed table-sm small m-0" v-show="!isLoading" :key="filter.category.length && filter.brand.length" >
                <tr>
                  <th class="clickable" @click="sort('id')" >
                    <span class="font-weight-bold" v-if="currentSort === 'id' && sortType === 'desc'">▼</span><span class="font-weight-bold" v-if="currentSort ==='id' && sortType === 'asc'">▲</span>
                    ID
                  </th>
                  <th v-if="showImages" >
                    Afbeelding
                  </th>
                  <th class="clickable" @click="sort('name')" style="width: 300px" >
                    <span class="font-weight-bold" v-if="currentSort === 'name' && sortType === 'desc'">▼</span><span class="font-weight-bold" v-if="currentSort ==='name' && sortType === 'asc'">▲</span>
                    Naam
                  </th>
                  <th class="clickable" @click="sort('currentStock')">
                    <span class="font-weight-bold" v-if="currentSort === 'currentStock' && sortType === 'desc'">▼</span><span class="font-weight-bold" v-if="currentSort ==='currentStock' && sortType === 'asc'">▲</span>
                    Voorraad
                  </th>

                  <th class="clickable" @click="sort('orders_7d')">
                    <span class="font-weight-bold" v-if="currentSort === 'orders_7d' && sortType === 'desc'">▼</span><span class="font-weight-bold" v-if="currentSort ==='orders_7d' && sortType === 'asc'">▲</span>
                    7d
                  </th>
                  <th class="clickable" @click="sort('orders_1m')">
                    <span class="font-weight-bold" v-if="currentSort === 'orders_1m' && sortType === 'desc'">▼</span><span class="font-weight-bold" v-if="currentSort ==='orders_1m' && sortType === 'asc'">▲</span>
                    1M
                  </th>
                  <th class="clickable" @click="sort('orders_1y')">
                    <span class="font-weight-bold" v-if="currentSort === 'orders_1y' && sortType === 'desc'">▼</span><span class="font-weight-bold" v-if="currentSort ==='orders_1y' && sortType === 'asc'">▲</span>
                    1Y
                  </th>
                  <th class="clickable" @click="sort('orders_custom')" v-if="dateFrom">
                    <span class="font-weight-bold" v-if="currentSort === 'orders_custom' && sortType === 'desc'">▼</span><span class="font-weight-bold" v-if="currentSort ==='orders_custom' && sortType === 'asc'">▲</span>
                    Invoer
                  </th>
                  <th class="clickable" @click="sort('omzet')" v-if="!dateFrom">
                    <span class="font-weight-bold" v-if="currentSort === 'omzet' && sortType === 'desc'">▼</span><span class="font-weight-bold" v-if="currentSort ==='omzet' && sortType === 'asc'">▲</span>
                    Omzet 1Y
                  </th>
                  <th class="clickable" @click="sort('omzet_custom')" v-if="dateFrom">
                    <span class="font-weight-bold" v-if="currentSort === 'omzet_custom' && sortType === 'desc'">▼</span><span class="font-weight-bold" v-if="currentSort ==='omzet_custom' && sortType === 'asc'">▲</span>
                    Omzet Invoer
                  </th>
                  <th class="clickable" @click="sort('engine')">
                    <span class="font-weight-bold" v-if="currentSort === 'engine' && sortType === 'desc'">▼</span><span class="font-weight-bold" v-if="currentSort ==='engine' && sortType === 'asc'">▲</span>
                    Engine advies
                  </th>
                </tr>
                <tr v-for="product in filteredProducts" class="clickable" v-if="productSettings[product.id]" :class="{'table-success': selectedProduct === product, 'table-danger': productSettings[product.id].stopped}" @click="selectProduct(product)">
                  <td>{{product.id}}</td>
                  <td v-if="showImages">
                    <img v-if="product.thumbnails && product.thumbnails.length > 0" :src="product.thumbnails[0]" width="100px" height="100px"/>
                  </td>
                  <td>{{product.name}}<br/>
                    <div class="badge badge-secondary">{{product.brand}}</div>
                    <div class="badge badge-info">{{product.category}}</div>
                    <div class="badge badge-warning">{{product.date_added | moment("from")}}</div>
                    <div class="badge badge-primary" v-if="productSettings[product.id].supplier">{{productSettings[product.id].supplier}}</div></td>
                  <td>{{product.currentStock}}</td>
                  <td>
                    <small :class="{'text-success': product.pct_7d > 0, 'text-danger': product.pct_7d < 0}">{{product.orders_7d}}</small><br/>
                    <small :class="{'text-success': product.pct_7d > 0, 'text-danger': product.pct_7d < 0}" v-if="product.pct_7d">{{product.pct_7d.toFixed(0)}}%</small>
                    <small class="text-muted" v-if="!product.pct_7d">N/A</small>
                  </td>
                  <td>
                    <small :class="{'text-success': product.pct_1m > 0, 'text-danger': product.pct_1m < 0}">{{product.orders_1m}}</small><br/>
                    <small :class="{'text-success': product.pct_1m > 0, 'text-danger': product.pct_1m < 0}" v-if="product.pct_1m">{{product.pct_1m.toFixed(0)}}%</small>
                    <small class="text-muted" v-if="!product.pct_1m">N/A</small>
                  </td>
                  <td>
                    <small :class="{'text-success': product.pct_1y > 0, 'text-danger': product.pct_1y < 0}">{{product.orders_1y}}</small><br/>
                    <small :class="{'text-success': product.pct_1y > 0, 'text-danger': product.pct_1y < 0}" v-if="product.pct_1y">{{product.pct_1y.toFixed(0)}}%</small>
                    <small class="text-muted" v-if="!product.pct_1y">N/A</small>
                  </td>
                  <td v-if="dateFrom">
                    <small>{{product.orders_custom}}</small><br/>
                  </td>
                  <td style="text-align: center" v-if="!dateFrom"><small>€ {{(product.orders_1y * product.price).toFixed(2)}}</small></td>
                  <td style="text-align: center" v-if="dateFrom"><small>€ {{(product.orders_custom * product.price).toFixed(2)}}</small></td>
                  <td style="text-align: center" v-if="product.engine && productOrderOverride[product.id]">
                    <div v-if="!productOrderOverride[product.id].amount">
                      <i class="fa fa-circle" :style="'color: ' + product.engine.color"></i> {{product.engine.value}}
                    </div>

                    <div v-if="productOrderOverride[product.id].amount">
                      <i class="fa fa-circle" style="color: blue"></i> {{productOrderOverride[product.id].amount}}
                    </div>
                  </td>
                </tr>
              </table>
              <div class="btn btn-block btn-sm" style="border-radius: 0" v-if="!showAll" @click="showAllProducts()">Toon alles</div>
              <div v-if="isLoading" class="text-center"><div class="lds-ripple"><div></div><div></div></div></div>
            </div>
          </card>
        </div>

      <div class="col-lg-5 col-md-12">
        <card v-if="selectedProduct && selectedProduct.name" style="height: calc(100vh - 110px); overflow-y: auto; margin-bottom: 0">
          <template slot="header">
            <h4 id="verkoop-overzicht" class="card-title">Verkoop overzicht</h4>
            <p class="card-category">Verkocht per week - tot 1 jaar terug</p>
          </template>

          <highcharts :options="chartOptions" style="height: 230px" v-for="product in products" v-if="selectedProduct == product"></highcharts>

          <hr/>
          <h4 class="my-1">Engine analyse</h4>

          <div v-if="selectedProduct.engine && selectedProduct.engine.value !== 'N/A'">
            <p class="text-muted">Huidige voorraad is: <b>{{selectedProduct.currentStock}}</b>.<br/>
              De engine verwacht niet meer dan <b>{{selectedProduct.engine.baseSupplyNeeded}}</b> verkochte producten in een week.<br/>
              De engine adviseert een minimale voorraad van: <b>{{selectedProduct.engine.baseSupplyPlusAdditionalPercentage}}</b><br/>
              Bestel dus: <b>{{selectedProduct.engine.toOrder}}</b>
            </p>
          </div>
          <div v-if="selectedProduct.engine && selectedProduct.engine.value === 'N/A'">
            <p class="text-muted">Geen engine advies mogelijk want: <br/>
              <b>{{selectedProduct.engine.text}}</b>
            </p>
          </div>

          <hr/>

          <div class="row">
            <div class="col" v-for="thumbnail in selectedProduct.thumbnails">
              <img :src="thumbnail" width="150px" height="150px;" @click="imageSelected = thumbnail.replace('-thumbnail.', '.')"/>
            </div>
            <div v-if='imageSelected' @close="imageSelected = false" style="border: 1px solid #ddd;">
                <img :src="imageSelected" style="width: 100%; height: 100%"/>
            </div>
          </div>

          <hr/>

          <div class="row">
            <div class="col-md-6">
              <h4 class="my-1">Verander besteladvies</h4>
              <form class="text-muted" v-on:submit.prevent="updateProductOrder">
                <div class="form-group mb-1" style="width: 100%">
                  <p>Bestel: <input type="number" id="change-advice" class="form-control form-control-sm" v-model="productOrderOverride[selectedProduct.id].amount"/></p>
                </div>
                <div class="form-group mb-1" style="width: 100%">
                  <p>Reden: <input type="text" class="form-control form-control-sm"  v-model="productOrderOverride[selectedProduct.id].reason"/></p>
                </div>
                <input type="submit" class="btn btn-default btn-sm" value="OPSLAAN">
                <label v-if="productOrderOverrideSaved !== selectedProduct.id">Of druk op Enter, om op te slaan.</label>
                <label v-if="productOrderOverrideSaved === selectedProduct.id" style="color: green; display: block">Opgeslagen.</label>
              </form>
            </div>
            <div class="col-md-6" style="border-left: 1px solid #ddd;">
              <h4 class="my-1">Instellingen</h4>
              <form class="text-muted" v-on:submit.prevent="updateProductSettings">
                <div class="form-group mb-1" style="width: 100%">
                  <p>Leverancier: <input type="text" class="form-control form-control-sm"  v-model="form.productSettings.supplier"/></p>
                </div>
                <div class="form-group mb-1" style="width: 100%">
                  <p>Stop met bijbestellen: <br/> <input type="checkbox" class="form-control form-control-sm " style="width: 20px;" v-model="form.productSettings.stopped"/></p>
                </div>
                <input type="submit" class="btn btn-default btn-sm" value="OPSLAAN">
                <label v-if="productSettingsSaved !== selectedProduct.id">Of druk op Enter, om op te slaan.</label>
                <label v-if="productSettingsSaved === selectedProduct.id" style="color: green; display: block">Opgeslagen.</label>
              </form>
            </div>

          </div>
        </card>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios'
  import moment from 'moment'
  moment.locale('en')
  import FilterModal from './component/FilterModal'
  import Highcharts from 'highcharts';

  export default {
    components: {
      FilterModal
    },
    data () {
      return {
        currentSort: '',
        sortType: 'asc',
        products: [],
        settings: {},
        selectedProduct: {},
        selectedCategory: undefined,
        search: '',
        filter: {category: [], brand: [], leverancier: []},
        isLoading: false,
        showAll: false,
        numberOfItems: 100,
        productSettings: {799: {}},
        productOrderOverride: {},
        productSettingsSaved: false,
        productOrderOverrideSaved: false,
        form: {
          productSettings: {}
        },
        dateFrom: undefined,
        dateTo: new Date().toISOString().split('T')[0],
        productCount: undefined,
        showImages: false,
        imageSelected: undefined
      }
    },
    watch: {
      // whenever question changes, this function will run
      dateFrom(newDate, oldDate) {
        if (!newDate) {
          return;
        }
        if (newDate !== oldDate) {
          this.calculateCustomDateRangeFields(newDate, this.dateTo)
        }
      },
      dateTo(newDate, oldDate) {
        if (!newDate) {
          return;
        }
        if (newDate !== oldDate) {
          this.calculateCustomDateRangeFields(this.dateFrom, newDate)
        }
      }
    },
    methods: {
      getProducts() {
        var self = this
        self.isLoading = true
        axios.get("/api/products")
          .then((response) => {
            self.products = response.data
            self.isLoading = false


            axios.get("/api/products/settings")
              .then((response) => {
                response.data.forEach((p) => {
                  self.productSettings[p.product_id] = p
                })
                self.products.forEach((p) => {
                  if (!self.productSettings[p.id]) {
                    self.productSettings[p.id] = {product_id: p.id}
                  }
                })
                self.$forceUpdate()
              })
              .catch((errors) => {
                console.log("Cannot get product settings")
                console.log(errors)
              })
            axios.get("/api/products/order")
              .then((response) => {
                response.data.forEach((p) => {
                  self.productOrderOverride[p.product_id] = p
                })
                self.products.forEach((p) => {
                  if (!self.productOrderOverride[p.id]) {
                    self.productOrderOverride[p.id] = {product_id: p.id}
                  }
                })
                self.$forceUpdate()
              })
              .catch((errors) => {
                console.log("Cannot get product order overrides")
                console.log(errors)
              })


          })
          .catch((errors) => {
            console.log("Cannot get products")
            console.log(errors)
          })
      },
      getSettings() {
        var self = this
        axios.get("/api/settings")
          .then((response) => {
            response.data.forEach((s) => {
              if (!s.value) {
                s.value = ''
              }
              self.settings[s.topic] = s;
            });
          })
          .catch((errors) => {
            console.log("Cannot get products")
            console.log(errors)
          })
      },
      sort(key) {
        self.isLoading = true
        if (key === 'omzet') {
          if (key === this.currentSort && this.sortType !== 'desc') {
            this.products = this.products.sort((a, b) => (b.orders_1y * b.price) - (a.orders_1y * a.price));
            this.sortType = 'desc';
          } else {
            this.products = this.products.sort((a, b) => (a.orders_1y * a.price) - (b.orders_1y * b.price));
            this.sortType = 'asc';
          }
          this.currentSort = key;
          self.isLoading = false
          return
        }
        if (key === 'omzet_custom') {
          if (key === this.currentSort && this.sortType !== 'desc') {
            this.products = this.products.sort((a, b) => (b.orders_custom * b.price) - (a.orders_custom * a.price));
            this.sortType = 'desc';
          } else {
            this.products = this.products.sort((a, b) => (a.orders_custom * a.price) - (b.orders_custom * b.price));
            this.sortType = 'asc';
          }
          this.currentSort = key;
          self.isLoading = false
          return
        }
        if (key === 'engine') {
          if (key === this.currentSort && this.sortType !== 'desc') {
            this.products = this.products.sort((a, b) => (b.engine.sort) - (a.engine.sort));
            this.sortType = 'desc';
          } else {
            this.products = this.products.sort((a, b) => (a.engine.sort) - (b.engine.sort));
            this.sortType = 'asc';
          }
          this.currentSort = key;
          self.isLoading = false
          return
        }

        if (typeof this.products[0][key] === "string") {
          if (key === this.currentSort && this.sortType !== 'desc') {
            this.products = this.products.sort((a, b) => a[key].localeCompare && a[key].localeCompare(b[key], 'en', { numeric: true }) ).reverse();
            this.sortType = 'desc';
          } else {
            this.products = this.products.sort((a, b) => a[key].localeCompare && a[key].localeCompare(b[key], 'en', { numeric: true }));
            this.sortType = 'asc';
          }
          this.currentSort = key;
        } else {
          if (key === this.currentSort && this.sortType !== 'desc') {
            this.products = this.products.sort((a, b) => b[key] - a[key]);
            this.sortType = 'desc';
          } else {
            this.products = this.products.sort((a, b) => a[key] - b[key]);
            this.sortType = 'asc';
          }
          this.currentSort = key;
        }
        self.isLoading = false
      },
      selectProduct(product) {
        this.selectedProduct = product;
        this.imageSelected = undefined;

        this.form.productSettings = Object.assign({}, this.productSettings[this.selectedProduct.id])
        setTimeout(() => {
          window.document.getElementById('verkoop-overzicht').scrollIntoView()
          window.document.getElementById('change-advice').focus()
        }, 200)
      },
      showProduct(product) {
        let show = true;
        if (this.selectedCategory) {
          show = product.category === this.selectedCategory;
        }
        if (show) {
          show = this.searchMatch(product);
        }
        if (show && this.filter.category && this.filter.category.length > 0) {
          show = this.filter.category.find((c) => c === product.category) !== undefined
        }
        if (show && this.filter.brand && this.filter.brand.length > 0) {
          show = this.filter.brand.find((c) => c === product.brand) !== undefined
        }
        if (show && this.filter.leverancier && this.filter.leverancier.length > 0) {
          show = this.filter.leverancier.find((c) => c === this.productSettings[product.id].supplier) !== undefined
        }

        if (show && this.filter.inStock) {
          show = product.currentStock > 0
        }
        if (show && this.filter.outOfStock) {
          show = product.currentStock <= 0
        }
        if (show && this.filter.sell7d) {
          show = product.orders_7d > 0
        }
        if (show && this.filter.sell1M) {
          show = product.orders_1m > 0
        }
        if (show && this.filter.sell1Y) {
          show = product.orders_1y > 0
        }

        if (show && this.filter.brandEmpty) {
          show = !product.brand
        }
        if (show && this.filter.supplierEmpty) {
          show = !this.productSettings[product.id].supplier
        }
        if (show && this.filter.stopped) {
          show = this.productSettings[product.id].stopped
        }
        if (show && this.filter.noEngine) {
          show = product.engine.value  === 'N/A'
        }
        if (show && this.filter.orderZero) {
          if (this.productOrderOverride[product.id].amount) {
            show = this.productOrderOverride[product.id].amount == 0;
          } else {
            show = product.engine.value == 0
          }
        }

        return show;
      },
      searchMatch(product) {
        if (!this.search) {
          return true
        }

        let keywords = this.search.split(',');

        for (let keyword of keywords) {
          let result = false;

          keyword = keyword.trim()

          if (!keyword.startsWith('-')) {
            if (product.name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1) {
              result = true;
            } else if ((product.id + '').indexOf(keyword) !== -1) {
              result = true;
            } else if ((product.reference + '').indexOf(keyword) !== -1) {
              result = true;
            }
          } else {
            result = true;
            keyword = keyword.replace('-', '')
            if (product.name.toLowerCase().indexOf(keyword.toLowerCase()) !== -1) {
              result = false;
            } else if ((product.id + '').indexOf(keyword) !== -1) {
              result = false;
            } else if ((product.reference + '').indexOf(keyword) !== -1) {
              result = false;
            }
          }

          if (result === false) {
            return false;
          }

        }

        return true

      },
      showAllProducts(){
        this.showAll = true
      },
      settingsToPlotBands() {
        let plotBands = []
        let settingsToTake = ['y2019_ramadan', 'y2019_eid_fitr', 'y2019_eid_adha', 'y2019_december', 'y2019_other',
          'y2020_ramadan', 'y2020_eid_fitr', 'y2020_eid_adha', 'y2020_december', 'y2020_other',
          'y2021_ramadan', 'y2021_eid_fitr', 'y2021_eid_adha', 'y2021_december', 'y2021_other',
          'y2022_ramadan', 'y2022_eid_fitr', 'y2022_eid_adha', 'y2022_december', 'y2022_other']

        for (const settingToTake of settingsToTake) {
          if (!this.settings[settingToTake].value) {
            continue;
          }
          let year = settingToTake.split('y')[1].split('_')[0];
          let weekStart = (-.5 + parseInt(this.settings[settingToTake].value.trim())) + ''
          let weekEnd =   (.5 + parseInt(this.settings[settingToTake].value.trim())) + ''

          if (this.settings[settingToTake].value.indexOf(',') !== -1) {
            weekStart = this.settings[settingToTake].value.split(',')[0].trim()
            weekEnd = this.settings[settingToTake].value.split(',').slice(-1)[0].trim()
          }

          plotBands.push({
            color: '#FED8B1', // Color value
            from: moment(year + ' ' + weekStart, 'YYYY w').toDate().getTime(), // Start of the plot band
            to: moment(year + ' ' + weekEnd, 'YYYY w').toDate().getTime(), // End of the plot band
          });
        }

        return plotBands
      },
      updateProductOrder() {
        let self = this
        axios.post('/api/products/order', this.productOrderOverride[this.selectedProduct.id])
          .then(() => {
            self.productOrderOverrideSaved = this.selectedProduct.id
            self.$forceUpdate()
          })
      },
      updateProductSettings() {
        let self = this
        this.productSettings[this.selectedProduct.id] = this.form.productSettings
        axios.post('/api/products/settings', this.productSettings[this.selectedProduct.id])
          .then(() => {
            self.productSettingsSaved = this.selectedProduct.id
            self.$forceUpdate()
          })
      },
      exportToCsv() {
        let filtered = this.products.filter((p) => this.showProduct(p))
        let data = {
          products: filtered.map((p) => p.id)
        }
        axios.post('/api/export/csv', data, {responseType: 'blob'}).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'export.csv'); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      },
      calculateCustomDateRangeFields(dateFrom, dateTo) {
        let dateFromYearWeek = moment(new Date(dateFrom)).format('YYYY w')
        let dateToYearWeek = moment(new Date(dateTo)).format('YYYY w')

        if (new Date(dateTo) > new Date(dateFrom)) {
          for (const product of this.products) {
            const orderIndex = Object.keys(product.orders);
            let start = orderIndex.indexOf(dateFromYearWeek)
            let end = orderIndex.indexOf(dateToYearWeek)

            product.orders_custom = 0;
            for (let i = start; i <= end; i++) {
              product.orders_custom += product.orders[orderIndex[i]] || 0;
            }
          }
        }
      }
    },
    mounted() {
      this.getProducts()
      this.getSettings()
    },
    computed: {
      filteredProducts: function() {
        var self = this;
        self.isLoading = true
        let filtered = this.products.filter((p) => this.showProduct(p))
        self.isLoading = false
        this.productCount = filtered.length
        if (!self.showAll) {
          return filtered.slice(0, this.numberOfItems);
        }
        return filtered
      },
      chartOptions: function () {
        var self = this

        let from = this.dateFrom ? new Date(this.dateFrom).getTime() : new Date(self.selectedProduct.date_added).getTime()
        let to = this.dateTo ? new Date(this.dateTo).getTime(): new Date().getTime()

        let interval = (to - from) / Object.keys(this.selectedProduct.orders).length
        console.log(interval)
        if (self.selectedProduct) {
          return {
            title: {
              text: self.selectedProduct.name
            },
            chart: {
              type: 'spline',
              zoomType: 'x',
              backgroundColor: "rgba(0,0,0,0)",
              height: 250,
            },
            yAxis: {
              title: {
                text: 'Aantallen'
              },
              min: 0
            },
            xAxis: {
              type: 'datetime',
              labels: {
                enabled: true,
                rotation: 45,
                align: 'left'
              },
              plotBands: this.settingsToPlotBands(),
              min: this.dateFrom ? new Date(this.dateFrom).getTime() : new Date(self.selectedProduct.date_added).getTime(),
              max: this.dateTo ? new Date(this.dateTo).getTime(): new Date().getTime()
            },
            plotOptions: {
              spline: {
                lineWidth: 4,
                states: {
                  hover: {
                    lineWidth: 5
                  }
                },
                dataLabels: {
                  crop: false,
                },
                cropThreshold: 1000,
                pointInterval: interval,
                pointStart: new Date(self.selectedProduct.date_added).getTime()
              }
            },
            series: [
              {
                name: 'verkocht',
                // for each order (per week),
                data: Object.entries(self.selectedProduct.orders).map((h) => {
                  return [ h[0], h[1]]
                }),
                color: '#555'
              },
              {
                name: 'voorraad',
                // for each order (per week),
                data: Object.entries(self.selectedProduct.stockCount).map((h) => {
                  return [ h[0], h[1]]
                }),
                color: '#F44'
              }]
          };
        }
      }
    }
  }
</script>
<style>
  .clickable {
  }
  .clickable:hover {
    background-color: #efefef;
    cursor: pointer !important;
  }


  tr th {
    position: sticky;
    top: 0;
    background-color: #efefef;
    margin-top: 0;
    border-top: 0 !important;
    z-index: 100;
  }

  .lds-ripple {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
  }
  .lds-ripple div {
    position: absolute;
    border: 4px solid #333;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }

  .form-control-sm {
    height: calc(1.5em + 0.5rem + 2px) !important;
    padding: 0.25rem 0.5rem !important;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem !important;
  }
</style>
